// responsiveFont.js
import { Dimensions } from "react-native";

const screenWidth = Dimensions.get("window").width || 360;

let scale = 1;
if (screenWidth < 360) scale = 0.85;
else if (screenWidth < 768) scale = 1;
else if (screenWidth < 1024) scale = 1.15;
else scale = 1.25;

export const responsiveFont = (size) => Math.round(size * scale);
